import React, { useEffect, useState } from "react";
import Card from "../../components/Card";
import Icon from "../../components/Icon";
import Modal from "../../components/Modal";
import { UseDisclosure } from "../../hooks/use-disclosure";
import styles from "./Social.module.sass";
import cn from "classnames";
import Dropdown from "../../components/Dropdown";
import TextInput from "../../components/TextInput";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import { GetBrand, UpdateBrand } from "../../Services/lib/brand";
import { UseApi } from "../../hooks/use-api";
import Loader from "../../components/Loader";
import Confirm from "../../components/Confirm";
import settings from "../../i11/Settings";
import { useUser } from "../../context";

const options = [
	"Facebook",
	"Telegram",
	"Instagram",
	"LinkedIn",
	"Discord",
	"Twitter",
	"Tiktok",
	"Pinterest",
	"Youtube",
];

const Row = ({ name, link, DeleteLink, Edit }) => {
	return (
		<div className={styles.row}>
			<TextInput className={styles.name} value={name} disabled />
			<TextInput className={styles.link} value={link} disabled />
			<button
				onClick={() => Edit(name)}
				className={cn("button", styles.IconButton)}
			>
				<Icon name="edit" size="24" />
			</button>
			<button
				onClick={() => DeleteLink(name)}
				className={cn("button button-stroke-red", styles.IconButton)}
			>
				<Icon name="trash" size="24" />
			</button>
		</div>
	);
};

const SocialLinks = () => {
	const { locale } = useUser();
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [selected, setSelected] = useState("");
	const [isEdit, setEdit] = useState(false);
	const [socials, setSocials] = useState({});
	const [initial, setInitial] = useState({});
	const [link, setLink] = useState("");

	const [deleteOpen, setDeleteOpen] = useState(false);

	const [{ isLoading }, updateSocial] = UseApi({
		service: UpdateBrand,
	});
	const [{ isLoading: initLoading }, getBrand] = UseApi({
		service: GetBrand,
	});

	const Close = () => {
		setLink("");
		setSelected("");
		setEdit(false);
		onClose();
	};

	const Init = async () => {
		const res = await getBrand();
		if (res) {
			setSocials(res.social || []);
			setInitial(res.social || []);
		}
	};

	useEffect(() => {
		Init();
	}, []);

	const addLink = () => {
		if (selected === "" || link === "") {
			ToastEmitter({
				type: "info",
				msg: "Select and promt both a platform name and link",
			});
		} else {
			let res = { ...socials, [selected]: link };
			setSocials(res);
			UpdateSocial(res);
			Close();
		}
	};
	const UpdateSocial = async (initSolials = {}) => {
		const res = await updateSocial({
			social: initSolials === {} ? socials : initSolials,
		});
		if (res) {
			setInitial(res.social || []);
			ToastEmitter({
				type: "success",
				msg: "Your social links successfully saved",
			});
		}

		setDeleteOpen(false);
	};

	const DeleteLink = (name) => {
		setSelected(name);
		setDeleteOpen(true);
	};

	const Edit = (name) => {
		setLink(socials[name]);
		setSelected(name);
		setEdit(true);
		onOpen();
	};

	return (
		<Card title={settings[locale].social_links} classTitle="title-green">
			{initLoading ? (
				<div className={styles.initwrap}>
					<Loader className={styles.loader} />
				</div>
			) : (
				<>
					{Object.keys(socials).map((e) => {
						return (
							<Row
								key={e}
								name={e}
								// DeleteLink={DeleteLink}
								DeleteLink={() => DeleteLink(e)}
								link={socials[e]}
								Edit={Edit}
							/>
						);
					})}
					<div className={styles.foot}>
						{/* {IsChanged(initial, socials) && (
              <button
                onClick={UpdateSocial}
                className={cn("button", { disabled: isLoading })}
              >
                {isLoading && <Loader />}
                <span>Changes save</span>
              </button>
            )} */}
						<button onClick={onOpen} className="button button-stroke">
							<Icon name="add" size="24" />
							<span>{settings[locale].add_link}</span>
						</button>
					</div>
				</>
			)}

			<Modal visible={isOpen} onClose={Close}>
				<div className={cn("title-blue", styles.title)}>
					{isEdit
						? settings[locale].edit_link_title
						: settings[locale].add_link_title}
				</div>
				{!isEdit && (
					<div className={styles.note}>
						{settings[locale].add_link_description}
					</div>
				)}
				<div className={styles.spacer} />
				{isEdit ? (
					<TextInput
						label={settings[locale].social_platform}
						value={selected}
						disabled
					/>
				) : (
					<Dropdown
						label={settings[locale].social_platform}
						value={selected}
						setValue={setSelected}
						options={options.filter((e) => !Object.keys(socials).includes(e))}
					/>
				)}
				<div className={styles.spacer} />
				<TextInput
					value={link}
					onChangeInput={setLink}
					name="link"
					type="text"
					placeholder="https://..."
					label={settings[locale].link}
				/>
				<div className={styles.spacer} />
				<div className={styles.foot}>
					<button onClick={addLink} className="button">
						{settings[locale].confirm}
					</button>
				</div>
			</Modal>

			<Modal visible={deleteOpen} onClose={() => setDeleteOpen(false)}>
				<Confirm
					isLoading={isLoading}
					onCancel={() => setDeleteOpen(false)}
					onConfirm={() => {
						let res = { ...socials };
						delete res[selected];
						UpdateSocial(res);
						setSocials(res);
					}}
					title={settings[locale].delete_link_title}
					note={socials[selected]}
				/>
			</Modal>
		</Card>
	);
};

export default SocialLinks;

const IsChanged = (a, b) => {
	const Break = "Changed";
	try {
		Object.keys(a).forEach((e) => {
			if (b[e] !== a[e]) throw Break;
		});

		Object.keys(b).forEach((e) => {
			if (b[e] !== a[e]) throw Break;
		});
		return false;
	} catch (error) {
		if (error !== Break) throw error;
		else return true;
	}
};
